import template from './gsk.jade';

export default angular
    .module('cian.addForm.gsk', [])
    .directive('cianAfAboutBuildingGsk', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
        },
        controllerAs: 'gsk',
        template,
    }))
    .name;
